import { Space } from 'antd';
import styles from './index.less';

export const HeaderTitleRender = ({ logo, title }) => {
  return (
    <Space style={{ cursor: 'pointer' }}>
      <div style={{ position: 'relative', top: '5px' }}>{logo}</div>
      <div className={styles.projectName}>{title}</div>
    </Space>
  );
};
